angular.module('account').controller('AccountActivationRequestCtrl',
    ['$scope', 'toaster', 'aprgettext', 'TransitionManager', 'SessionService', 'AccountRepository', 'LocalStorageRepository',
        function ($scope, toaster, gettext, TransitionManager, SessionService, AccountRepository, LocalStorageRepository) {
            'use strict';

            $scope.loading = false;

            //todo use Ryan's date picker
            $scope.question = {
                SurveySectionId: 1,
                SurveyQuestionId: 2,
                SelectedAnswerText: '',
                SectionOptional: true,
                QuestionOptional: true
            };
            $scope.accountActivationDto = {
                ClientId: LocalStorageRepository.getClientID(),
                EmailAddress: '',
                Birthdate: ''
            };

            function activateAccountRequest() {
                if ($scope.accountRequestValidationForm.$invalid){
                    return;
                }
                $scope.submitLoading = true;
                $scope.accountActivationDto.Birthdate = $scope.question.SelectedAnswerText && new Date($scope.question.SelectedAnswerText);
                AccountRepository.postAccountActivationRequest($scope.accountActivationDto)
                    .then(function () {
                        toaster.pop('success', '', gettext('Account activation email sent.'));
                        TransitionManager.transition({appRoute: 'login'});
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('An error has occurred. Email failed to send or we were unable to find your account.'));
                    })
                    .finally(function () {
                        $scope.submitLoading = false;
                    });
            }

            function back() {
                SessionService.setDisplayDashboardToolbar(false);
                TransitionManager.transition({appRoute: 'login'});
            }

            function onLoad() {
                AccountRepository.getActivatePatientPortalRequestMetadata($scope);
            }

            onLoad();

            $scope.back = back;
            $scope.activateAccountRequest = activateAccountRequest;

        }]);


